import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import SVG from 'components/SVG';

import { formatePoints } from 'features/bonusProgram/data/formatePoints';

import editSVG from 'features/bonusProgram/data/img/edit.svg';
import './CurrentGiftsItem.scss';

const b = block('current-gifts-item-desktop');

const CurrentGiftsItem = ({ item }) => {
  const locale = useSelector(s => s.locale.locale);

  return (
    <section className={b()}>
      <div className={b('item')}>{item.name}</div>
      <a href={item.imageUrl} target='_blank' rel="noopener noreferrer" className={b('item')}>
        <div className={b('ellipsis')}>{item.imageUrl}</div>
      </a>
      <div className={b('item')}>{formatePoints(item.points, 2, 0)}</div>
      <div className={b('item', { status: item.active ? '1' : '0' })}>{item.active ? locale.active : locale.disable2}</div>
      <Link className={b('item')} to={`/bonus-promo/management/${item.id}`}>
        <SVG className={b('icon')} svgProps={{ svg: editSVG }} />
        {locale.edit}
      </Link>
    </section>
  );
};

export default CurrentGiftsItem;
